<template>
  <div class="app-container">
    <router-view v-if="meta.sessionRestoreCompleted" />
    <splash v-else></splash>
    <div>
      <exception-dialog v-model:errors="errors"></exception-dialog>
    </div>
  </div>
</template>
<script>
import "tinymce/tinymce";
import "tinymce/plugins/code";
import "tinymce/plugins/lists";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/link";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/skins/content/dark/content.min.css";
import "tinymce/models/dom";
import "vue-json-viewer/style.css";

import "./assets/scss/main.scss";

import { mapActions, mapState } from "vuex";
import splash from "./common/views/Splash.vue";
import ExceptionDialog from "./ContentEditor/components/ErrorHandling/ExceptionDialog.vue";
import emitter from "tiny-emitter/instance";
import eventLogger from "./services/ApiLogger/EventLogger";
import tinymce from "tinymce/tinymce";

export default {
  data() {
    return { errors: [] };
  },
  computed: {
    ...mapState(["user", "meta"]),
    ...mapState("contentEditor/article", ["metadata"])
  },
  methods: {
    ...mapActions(["tryRestore"]),
    updateNow() {
      if (this.newWorker) {
        this.newWorker.postMessage({ type: "SKIP_WAITING" });
      }
    },
    globalErrorHandler(errors) {
      this.errors.push(...(Array.isArray(errors) ? errors : [errors]));
    },
    cspErrorHandler(cspState) {
      this.errors.push({
        type: "csp",
        cspState: cspState
      });
    },

    resizeStandaloneWindow() {
      if (!matchMedia("(display-mode: browser)").matches) {
        const minimumWidth = 1280;
        const minimumHeight = 796;

        const outerWidth = window.outerWidth;
        const outerHeight = window.outerHeight;

        const innerWidth = document.documentElement.clientWidth;
        const innerHeight = document.documentElement.clientHeight;

        let newWidth = outerWidth;
        let newHeight = outerHeight;

        if (innerWidth < minimumWidth) newWidth = minimumWidth + (outerWidth - innerWidth);

        if (innerHeight < minimumHeight) newHeight = minimumHeight + (outerHeight - innerHeight);

        window.resizeTo(newWidth, newHeight);
      }
    }
  },

  mounted() {
    const me = this;
    eventLogger.info("Medapro Cloud", "Webapp started.");

    //PWA resize, when started on Device as App
    me.resizeStandaloneWindow();

    //Retrigger loaded DOM to resize PWA
    window.onappinstalled = () => {
      window.addEventListener(
        "resize",
        () => {
          me.resizeStandaloneWindow();
        },
        { once: true }
      );
    };

    this._handler = (e) => {
      const target = e.originalTarget || e.target;
      try {
        if (target.classList.contains("tox-tinymce") || target.closest(".tox-tinymce")) {
          return;
        }

        const editors = tinymce.EditorManager.get();
        editors.forEach((editor) => {
          if (editor.queryCommandState("ToggleToolbarDrawer")) {
            editor.execCommand("ToggleToolbarDrawer");
          }
        });
      } catch {
        // eslint-disable-next-line
      }
    };

    document.addEventListener("click", this._handler);
    emitter.on("global-error", this.globalErrorHandler);
    emitter.on("csp-error", this.cspErrorHandler);
  },
  components: {
    splash,
    ExceptionDialog
  },
  beforeUnmount() {
    emitter.off("global-error", this.globalErrorHandler);
    emitter.off("csp-error", this.cspErrorHandler);
    document.removeEventListener("click", this._handler);
  }
};
</script>
